var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group",class:'level-'+_vm.level},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }